import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import fr from 'facet-rest';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { openModal } from 'Helpers/ModalHelper';
import modalConsts from 'Consts/ModalNames';
import MuiAddCircleIcon from '@material-ui/icons/AddCircle';
import useEventTrackingLogEvent from 'EventTracking/useEventTrackingLogEvent';
import Button from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Button';
import Icon from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Icon';
import { pickImplementation } from 'Helpers/Affordances';
import useUserContext from 'Context/UserContext';
import { useListContextState } from 'Components/UI/ListDetailView/ListContext';
import moment from 'moment-timezone';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import history from 'State/history';
import { advisorHouseholdSchedulerUri } from 'Consts/advisorUris';

const styles = theme => ({
  root: {},
  row: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    padding: theme.spacing(1),
    backgroundColor: theme.palette.facet.lightGray,
  },
  rowFirst: {
    height: theme.heights.tabs,
    background: theme.palette.primary.main,
  },
  title: {
    lineHeight: `${theme.spacing(3)}px`,
  },
  hidden: {
    display: 'none',
  },
});

const ListHeader = ({
  className,
  classes,
}) => {
  const { agentResource } = useUserContext();
  const { householdResource } = useSimpleHousehold();
  const { logEvent } = useEventTrackingLogEvent();
  const { resources } = useListContextState();
  const areMeetingsCategorized = resources
    .filter(resource => moment().isSameOrAfter(resource.attr('startTime')))
    .every(resource => resource.attr('status') !== 'uncategorized');

  const handleScheduleMeetingClick = pickImplementation(agentResource, {
    [fr.relationships.default.name]: async () => {
      logEvent('Clicked Schedule Next Item');
      if (areMeetingsCategorized) {
        const [nextProjectedMeeting] = await householdResource.relationship(fr.relationships.projectedMeetings.name).link('related').Get({
          params: {
            tz: moment.tz.guess(),
          },
        });
        history.push(advisorHouseholdSchedulerUri(householdResource.id(), {
          link: nextProjectedMeeting.relationship(fr.relationships.projectedMeetingAvailabilityPeriod.name).link('related').url(),
          projectedMeetingLink: nextProjectedMeeting.link('self').url(),
        }));
      } else {
        openModal(modalConsts.uncategorizedMeetingModal);
      }
    },
  });

  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <Box
        className={classNames(classes.row, classes.rowFirst)}
      >
        <Button
          color="white"
          disableElevation
          variant={'text'}
          test="schedule-next-item-button"
          onClick={handleScheduleMeetingClick}
          startIcon={(
            <Icon
              fill={'secondary'}
              icon={MuiAddCircleIcon}
            />
          )}
        >
          {'Schedule Meeting'}
        </Button>
      </Box>
    </Box>
  );
};

ListHeader.defaultProps = {
  className: '',
};

ListHeader.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ListHeader);
